import { VisitorEventService } from './../../services/visitor.event.service';
import { Component, Input } from '@angular/core';
import { VisitorEvent } from 'src/app/modules/shared/models/visitor.event';
import {
  IAppState,
  IFrontendSettings,
} from 'src/app/modules/shared/ngrx.stores/frontend.settings/states';
import { select, Store } from '@ngrx/store';
import { frontendSettingsSelector } from 'src/app/modules/shared/ngrx.stores/frontend.settings/selectors';

@Component({
  selector: 'ig-info-ticket',
  templateUrl: './info.ticket.component.html',
  styleUrls: ['./info.ticket.component.scss'],
})
export class InfoTicketComponent {
  @Input() event: VisitorEvent;
  settings: IFrontendSettings;

  constructor(
    public eventService: VisitorEventService,
    private _store: Store<IAppState>
  ) {
    this._store.pipe(select(frontendSettingsSelector)).subscribe((settings) => {
      settings && (this.settings = settings);
    });
  }

  extractMainDomain(url) {
    try {
      const domain = new URL(url).hostname;
      const mainDomain = domain.replace(/^www\./, '');
      return mainDomain;
    } catch (error) {
      console.error('Invalid URL:', error);
      return null;
    }
  }
}
